import data from '@/data/spotify-episodes.json'

export type SpotifyEpisode = {
  id: string
  name: string
  description: string
  release_date: string
  duration_ms: number
  external_urls: { spotify: string }
  images: { url: string; height: number; width: number }[]
  html_description?: string
}

const episodes = data.episodes as SpotifyEpisode[]

export function getEpisode(episodeId: string): SpotifyEpisode | null {
  return episodes.find((ep) => ep.id === episodeId) ?? null
}

export function getLatestEpisodes(limit = 6): SpotifyEpisode[] {
  return episodes.slice(0, limit)
}

export function formatDuration(ms: number): string {
  const minutes = Math.round(ms / 60000)
  if (minutes < 60) return `${minutes} min`
  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60
  return remainingMinutes > 0 ? `${hours} u ${remainingMinutes} min` : `${hours} u`
}
